import React, { useState } from 'react'
import { Star, StarFill } from 'react-bootstrap-icons'

export const RATING_LABELS = ['', 'Poor', 'Fair', 'Good', 'Very good', 'Excellent']

export default function StarPicker({ value, onChange, error }) {
  const [hovered, setHovered] = useState(0)
  const shown = hovered || value

  return (
    <div>
      <div className="flex items-center gap-3">
        <div className="flex items-center" onMouseLeave={() => setHovered(0)}>
          {[1, 2, 3, 4, 5].map(star => (
            <button
              key={star}
              type="button"
              aria-label={`${star} star${star > 1 ? 's' : ''}`}
              className="p-1 text-yellow-400 transition-transform hover:scale-110 focus:outline-none"
              onMouseEnter={() => setHovered(star)}
              onClick={() => onChange(star)}
            >
              {star <= shown ? <StarFill className="w-7 h-7" /> : <Star className="w-7 h-7" />}
            </button>
          ))}
        </div>
        <span className={`text-sm font-semibold ${shown ? 'text-rb-black dark:text-white' : 'text-gray-400'}`}>
          {shown ? `${shown}/5 · ${RATING_LABELS[shown]}` : 'Select a rating'}
        </span>
      </div>
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  )
}
